import React from 'react';
import SERVICES_LIST  from '../../constants/servicesList';
import { Table } from 'antd';

const columns = [
    {
        title: 'Service Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
    },
    {
        title: 'Duration (mins)',
        dataIndex: 'duration',
        key: 'duration',
    },
];

function createTableData() {
    return SERVICES_LIST.map(item => {
        return {
            key: item.gka,
            name: item.price ? item.service : `${item.service} - can only book via manual booking`,
            price: item.price ? `£${item.price}` : 'N/A',
            duration: item.duration_plus_travel,
        };
    });
}

const ServicesTable = () => {
    return (
        <Table
            dataSource={createTableData()}
            columns={columns}
            pagination={false}
            bordered
        />
    );
};

export default ServicesTable;
